module.exports = __webpack_public_path__ + "static/left-middle-2820dcc16542923983ba86a2f9cc3a6b.png";